import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

export const chartContainer = style({
  backgroundColor: semanticThemeTokens.chart.backgroundColor,
  borderRadius: primitiveTokens.radii.sm,
  border: `1px solid ${semanticThemeTokens.chart.borderColour}`,
  paddingBottom: primitiveTokens.sizing["2x"]
});

export const chartWrapper = style({
  height: "500px"
});

export const chartMultiContainer = style({
  display: "flex",
  flexDirection: "row",
  gap: primitiveTokens.sizing["3x"],
  paddingTop: primitiveTokens.sizing["2x"],
  paddingBottom: primitiveTokens.sizing["2x"],
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center"
});

export const chartMultiItem = style({
  flex: 1
});

export const chartPanelLayout = style({
  display: "flex",
  flexDirection: "column",
  height: "100%"
});

export const chartPanelControls = style({
  display: "flex",
  padding: "0.25rem 0.5rem"
});
